import {Coords} from 'google-map-react';

export enum ScreenTypes {
  EV_SURVEY_CTA = 'EV_SURVEY_CTA',
  EV_MAP_LANDING = 'EV_MAP_LANDING',
  EVEE_CHAT_CTA = 'EVEE_CHAT_CTA',
  EVEE_CHAT_INPUT_LANDING = 'EVEE_CHAT_INPUT_LANDING',
  EV_AMPOL_AMP_CHARGE = 'EV_AMPOL_AMP_CHARGE',
  EV_VW_70_YEAR_CELEBRATION = 'EV_VW_70_YEAR_CELEBRATION',
}

export const isDevelopment = process.env.NODE_ENV === 'development';

export const DevelopmentScreenTypes: Record<string, ScreenTypes> = {
  [`/default/${ScreenTypes.EV_MAP_LANDING}`]: ScreenTypes.EV_MAP_LANDING,
  [`/default/${ScreenTypes.EVEE_CHAT_CTA}`]: ScreenTypes.EVEE_CHAT_CTA,
  [`/default/${ScreenTypes.EVEE_CHAT_INPUT_LANDING}`]:
    ScreenTypes.EVEE_CHAT_INPUT_LANDING,
  [`/default/${ScreenTypes.EV_SURVEY_CTA}`]: ScreenTypes.EV_SURVEY_CTA,
  [`/default/${ScreenTypes.EV_AMPOL_AMP_CHARGE}`]:
    ScreenTypes.EV_AMPOL_AMP_CHARGE,
  [`/default/${ScreenTypes.EV_VW_70_YEAR_CELEBRATION}`]:
    ScreenTypes.EV_VW_70_YEAR_CELEBRATION,
};

export enum GPSTourBrandExperiences {
  ID4 = 'ID4',
  AMAROK = 'AMAROK',
}

export const GPSTourBranchConfig: Record<
  GPSTourBrandExperiences,
  {event: string; keyword: string; centerPosition: Coords; defaultZoom: number}
> = {
  [GPSTourBrandExperiences.ID4]: {
    event: '15113',
    keyword: 'russtralia2',
    centerPosition: {lat: -29.291517, lng: 135.744228},
    defaultZoom: 4.5,
  },
  [GPSTourBrandExperiences.AMAROK]: {
    event: '15264',
    keyword: 'russtralia',
    centerPosition: {lat: 7.075543, lng: -11.540237},
    defaultZoom: 3,
  },
};
